export default {
    ROOT: {
        PATH: '/',
        NAME: 'page-stocks',
    },
    STOCK: {
        PATH: '/stock/:symbol',
        NAME: 'page-stock',
    },
};
